import { Buffer } from "buffer";
const IconCross = (color: string = "#fff") => {
  const icon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20.315" height="20.316" viewBox="0 0 20.315 20.316">
      <g id="グループ_4504" data-name="グループ 4504" transform="translate(-499.502 -1205.923)">
        <path id="パス_7280" data-name="パス 7280" d="M500.209,1206.631l18.9,18.9" fill="none" stroke="${color}" stroke-width="2"/>
        <path id="パス_7281" data-name="パス 7281" d="M500.209,1206.631l18.9,18.9" transform="translate(-706.422 1725.74) rotate(-90)" fill="none" stroke="${color}" stroke-width="2"/>
      </g>
    </svg>
    `;
  const base64 =
    "data:image/svg+xml;base64," + Buffer.from(icon).toString("base64");
  return base64;
};

export default IconCross;
